module.exports = __webpack_public_path__ + "096748e73fe2e69181d7c845c6213516.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/spacemarines-vignette-preview.jpg
// module id = 551
// module chunks = 0